import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { RequestForQuoteFormModel } from "@tFissco/ApiModels";
import { addRequestForQuoteFormFields as addRequestForQuoteApi } from "@tFissco/Services/RequestForQuoteService";

type rfqParameter = {
    firstName: string;
    lastName: string;
    company: string;
    jobTitle: string;
    phone: string;
    emailAddress: string;
    accountNumber: string;
    mfrName: string;
    mpn: string;
    modelNumber: string;
    serialNumber: string;
    quantity: string;
    pickUpDelivery: string;
    description: string;
    attachment: any;
    country: string;
    onSuccess?: () => void;
    onError?: (error: string, statusCode?: number) => void;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<rfqParameter, RequestForQuoteFormModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    await addRequestForQuoteApi(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const addRequestForQuoteFormFields = createHandlerChainRunner(chain, "AddRequestForQuoteFormFields");
export default addRequestForQuoteFormFields;
